import {fromJS} from 'immutable';
import {
  AUDIO_SET_ENABLED,
  AUDIO_SET_VAD_ENABLED,
  AUDIO_SET_STT_ENABLED,
  AUDIO_TRANSCRIBE_REQUEST,
  AUDIO_TRANSCRIBE_RESULT,
  AUDIO_ERROR,
  AUDIO_SET_HEARING,
  AUDIO_SET_ROBOT_SPEAKING,
  ENABLED,
  VAD_ENABLED,
  STT_ENABLED,
  IS_TRANSCRIBING,
  LAST_ERROR,
  ROBOT_SPEAKING,
  HEARING,
  HIGHLIGHT_RANGE, SET_HIGHLIGHT_RANGE,
  TTS_MOOD, AUDIO_SET_TTS_MOOD,
  AUDIO_SET_TTS_HEALTH,
  TTS_SERVER_OK,
  TTS_LAST_ERROR,
  TTS_LAST_CHECKED_AT, AWAITING_STT_FOLLOWUP, AUDIO_SET_AWAITING_STT_FOLLOWUP,
} from './consts'

const initialState = fromJS({
  [ENABLED]: true,
  [VAD_ENABLED]: true,
  [STT_ENABLED]: true,
  [IS_TRANSCRIBING]: false,
  [LAST_ERROR]: null,
  [HEARING]: 'silence',
  [ROBOT_SPEAKING]: false,
  [HIGHLIGHT_RANGE]: { start: -1, end: -1 },
  [TTS_MOOD]: null,
  [TTS_SERVER_OK]: true,
  [TTS_LAST_ERROR]: null,
  [TTS_LAST_CHECKED_AT]: null,
  [AWAITING_STT_FOLLOWUP]: false,
})

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case AUDIO_SET_ENABLED:
      return state.set(ENABLED, action.enabled)

    case AUDIO_SET_VAD_ENABLED:
      return state.set(VAD_ENABLED, action.enabled)

    case AUDIO_SET_STT_ENABLED:
      return state.set(STT_ENABLED, action.enabled)

    case AUDIO_TRANSCRIBE_REQUEST:
      return state.set(IS_TRANSCRIBING, true)

    case AUDIO_TRANSCRIBE_RESULT:
      return state.set(IS_TRANSCRIBING, false)

    case AUDIO_ERROR:
      return state.set(LAST_ERROR, String(action.error || 'unknown audio error'))
        .set(IS_TRANSCRIBING, false)

    case AUDIO_SET_HEARING:
      return state.set(HEARING, action.hearing)

    case AUDIO_SET_ROBOT_SPEAKING:
      return state.set(ROBOT_SPEAKING, !!action.speaking)

    case AUDIO_SET_TTS_MOOD:
      return state.set(TTS_MOOD, action.mood ?? null)

    case AUDIO_SET_TTS_HEALTH:
      return state
        .set(TTS_SERVER_OK, !!action.payload?.isOk)
        .set(TTS_LAST_ERROR, action.payload?.error ?? null)
        .set(TTS_LAST_CHECKED_AT, action.payload?.checkedAt ?? Date.now())

    case SET_HIGHLIGHT_RANGE:
      return state.set(HIGHLIGHT_RANGE, fromJS(action.payload))

    case AUDIO_SET_AWAITING_STT_FOLLOWUP:
      return state.set(AWAITING_STT_FOLLOWUP, !!action.awaiting)

    default:
      return state;
  }
}
